import { Dispatch, useReducer } from 'react';
import { useViewportSize } from '../../../../hooks/useViewportSize';
import { SECTION_INDEX_UPDATE, SUB_NAV_HEIGHT_UPDATE } from './actions';
import { mapStateToProps } from './selectors';
import { Action, ReducerState, State } from '../types';

const initialState = {
  sectionIndex: 0,
  prevSectionIndex: null,
  subNavHeight: 0,
};

export function reducer(
  state: ReducerState,
  { payload, type }: Action,
): ReducerState {
  switch (type) {
    case SUB_NAV_HEIGHT_UPDATE: {
      return { ...state, subNavHeight: payload };
    }
    case SECTION_INDEX_UPDATE: {
      if (payload === state.sectionIndex) return state;
      return {
        ...state,
        sectionIndex: payload,
        prevSectionIndex: state.sectionIndex,
      };
    }
    default: {
      return state;
    }
  }
}

export function useAnimationsSectionReducer(): [State, Dispatch<Action>] {
  const [reducerState, dispatch] = useReducer(reducer, initialState);

  const viewPortState = useViewportSize();

  const state = mapStateToProps({ ...reducerState, ...viewPortState });

  return [state, dispatch];
}
